<template>
  <div>
    <Translator :countries="getCountries" />
  </div>
</template>

<script>
import { Translator } from "vue-google-translate";
import {mapGetters} from "vuex";
export default {
  name: "ConvertLanguageComponent",
  computed: {
    ...mapGetters(['getCountries']),
  
  },
  components: {
    Translator,
  },
  data() {
    return {
   
    };
  },

  methods: {},
};
</script>
